import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { LOG } from 'util/constants'
import { enhancedEventKeRlog } from 'util/index'

const WorkspaceClient = dynamic(() => import('components/WorkspaceClient'), {
  ssr: false,
})

export default function Workpsace() {
  const { query } = useRouter()

  useEffect(() => {
    enhancedEventKeRlog('page_enter', {
      page_name: '创作IDE页',
      type: 'python',
      from:
        (LOG.visit_ide as Record<string, string>)[query.from as string] ||
        '其他',
    })
  }, [query.from])

  return <WorkspaceClient />
}
